module.exports = __webpack_public_path__ + "img/noData.74d78e22.png";